import { render, staticRenderFns } from "./ProductQrcode.vue?vue&type=template&id=2a567206&"
import script from "./ProductQrcode.vue?vue&type=script&lang=js&"
export * from "./ProductQrcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports